module.exports = __webpack_public_path__ + "media/images/hitfun/icon.profile.white-65a01a1a6a27754872a29f4f2e885820.svg";